/**
 * EventBus
 * Defines expected events
 * disppatches events by type
 * handles event listeners by type
 * _app_events.js
 **/
;(function () {
	Shopify.theme = Shopify.theme || {}
	let EventBus = function () {
		let $this = {}
		$this.addingToCart = false
		$this.addedToCart = false
		$this.types = {
			AddingToCart: 'mx_shopify.cart.adding',
			AddedToCart: 'mx_shopify.cart.added',
			GettingCart: 'mx_shopify.cart.getting',
			CartUpdated: 'mx_shopify.cart.updated',
			RemovedFromCart: 'mx_shopify.cart.removed',
			QuantityUpdated: 'mx_shopify.quantity.updated',
			OptionsSelected: 'mx_shopify.options.selected',
			AjaxCartRefreshed: 'mx_shopify.cart.ajax.refreshed',
		}
		$this.dispatch = function ($event, $data) {
			$data = typeof $data !== 'undefined' ? $data : {}
			document.dispatchEvent(new CustomEvent($event, { detail: $data }))
		}
		$this.on = function ($event, func) {
			document.addEventListener($event, func)
		}
		$this.off = function ($event, func) {
			document.removeEventListener($event, func)
		}
		return $this
	}

	Shopify.theme.eventBus = new EventBus()
})()

/**
 * Global Cart Service
 * Holds the current state of the cart
 * handles updating quantity and removing items
 * TODO : Move add to cart functionality here.
 * _app-cart-service.js
 **/
;(function () {
	Shopify.theme = Shopify.theme || {}
	let $events = Shopify.theme.eventBus
	let CartService = function () {
		let $this = {}
		$this.cart = false
		$this.currentProduct = false
		$this.productAdded = false

		$this.init = function () {
			$this.getCart()
			$events.on($events.types.AddingToCart, $this.AddingToCart)
			$events.on($events.types.AddedToCart, $this.addedToCart)
		}
		$this.addingToCart = function ($data) {
			$this.currentProduct = $data.detail
		}
		$this.addedToCart = function ($data) {
			$this.productAdded = $data
			$this.getCart()
		}

		$this.getCart = function () {
			$.get('/cart.json').done(function (res) {
				$this.cart = res
				// $this.cart.total_price = $this.getCartSubTotal();
				$this.addCustomItemCount()
				$events.dispatch($events.types.CartUpdated, $this.cart)
			})
		}
		$this.addCustomItemCount = function () {
			let customCount = 0
			if ($this.cart.items.length > 0) {
				$this.cart.items.forEach((item) => {
					if (
						item.properties &&
						typeof item.properties._is_bundle_product == 'undefined'
					) {
						customCount = customCount + item.quantity
					}
				})
			}
			$this.customCount = customCount
		}

		$this.getCartSubTotal = function () {
			let subTotal = 0
			$this.cart.items.forEach((item) => {
				let price = item.final_line_price
				if (item.properties && item.properties._bundle_discount_percentage) {
					let discount = parseFloat(item.properties._bundle_discount_percentage)
					discount = price * discount
					price = price - discount
				}
				subTotal += price
			})
			return subTotal
		}

		$this.removeItem = function (key, notifiy = true) {
			var params = {
				url: '/cart/change.js',
				data: { quantity: 0, id: key },
				dataType: 'json',
			}
			let $promise = new Promise(function (resolve, reject) {
				$.post(params)
					.done(function (res) {
						$this.cart = res
						resolve({ cart: res, success: true })
						if (notifiy) {
							$events.dispatch($events.RemovedFromCart, {
								cart: $this.cart,
								key: key,
							})
							$events.dispatch($events.types.CartUpdated, $this.cart)
						}
					})
					.fail(function (res) {
						resolve({ success: false })
					})
			})
			return $promise
		}

		$this.updateQuantity = function (key, value, notifiy = true) {
			let $promise = new Promise(function (resolve, reject) {
				var params = {
					url: '/cart/change.js',
					data: { quantity: value, id: key },
					dataType: 'json',
				}
				$.post(params)
					.done(function (res) {
						$this.cart = res
						resolve({ cart: res, success: true })
						if (notifiy) {
							$events.dispatch($events.types.CartUpdated, $this.cart)
						}
					})
					.fail(function () {
						resolve({ success: false })
					})
			})
			return $promise
		}

		$this.updateQuantity__update = function (updates) {
			let $promise = new Promise(function (resolve, reject) {
				var params = {
					url: '/cart/update.js',
					data: { updates: updates },
					dataType: 'json',
				}
				$.post(params)
					.done(function (res) {
						$this.cart = res
						resolve({ cart: res, success: true })
						$events.dispatch($events.types.CartUpdated, $this.cart)
					})
					.fail(function () {
						resolve({ success: false })
					})
			})
			return $promise
		}

		$this.getCartItemByUID = function (uid) {
			if (!$this.cart || !$this.cart.items) {
				return false
			}

			item = $this.cart.items.find((item) => item.properties._uid === uid)
			if (item) {
				return item
			} else {
				return false
			}
		}

		$this.init()
		return $this
	}
	Shopify.theme.CartService = new CartService()
})()

/**
 * _app.js
 **/
;(function () {
	if (typeof window.CustomEvent === 'function') return false

	function CustomEvent(event, params) {
		params = params || { bubbles: false, cancelable: false, detail: null }
		var evt = document.createEvent('CustomEvent')
		evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail)
		return evt
	}

	window.CustomEvent = CustomEvent
})()

/**
 * _component.add-to-cart-button.js
 */

/**
 * AddToCartButton Component
 *
 **/
;(function () {
	Shopify.theme = Shopify.theme || {}
	let $events = Shopify.theme.eventBus
	let $cartService = Shopify.theme.CartService

	let AddToCartButton = function ($element) {
		let $this = {}
		$this.classes = {
			loading: 'loading',
			productId: false,
		}
		$this.selectors = {
			addToCartText: '[data-add-to-cart-text]',
		}
		$this.init = function () {
			$this.element = $($element)
			$this.form = $this.element.closest('[sh-product-form]')
			$this.productId = $this.form.data('productId')
			$this.addToCartText = $($this.selectors.addToCartText, $element)
			$events.on($events.types.AddingToCart, $this.addingToCart)
			$events.on($events.types.AddedToCart, $this.addedToCart)
		}
		$this.addingToCart = function ($data) {
			if ($this.productId == $data.detail.id) {
				$this.element.addClass($this.classes.loading)
				$this.addToCartText.text('Adding...')
			}
		}
		$this.addedToCart = function ($data) {
			if ($data.detail.success == true) {
				console.log( $data.detail.items)
				let variant = false
				if(  $data.detail.variant  ){
					variant = $data.detail.variant
				}
				if( $data.detail.items   ){
					variant = $data.detail.items[0]
				}
				if ($this.productId == variant.product_id) {
					$this.element.removeClass($this.classes.loading)
					$this.addToCartText.text('Cart Updated.')
					window.setTimeout(function () {
						$this.addToCartText.text('Add To Cart')
					}, 1000)
				}
			} else {
				$this.element.removeClass($this.classes.loading)
				$this.addToCartText.text('Add To Cart')
			}
		}
		$this.init()
		return $this
	}
	Shopify.theme.AddToCartButton = AddToCartButton
	$('[data-add-to-cart]').each(function () {
		let $btn = AddToCartButton(this)
	})
})()

/**
 * QuantiyButton Component
 * expects a wrapper element
 * requires element to have three defined data elements
 * for increase and decrease buttons and the quantitiy input
 * Dispatches an event for use in cart
 * _component.quantity.js
 **/
;(function () {
	Shopify.theme = Shopify.theme || {}
	let $events = Shopify.theme.eventBus
	let QuantityComponent = function ($containerElement) {
		let $this = {}
		$this.init = function () {
			$this.defaults = { minValue: 0, maxValue: 1000 }
			$this.timeout = false
			$this.container = $containerElement
			$this.data = $containerElement.data()
			$this.data = Object.assign($this.defaults, $this.data)
			$this.quantityDec = $('[data-quantity-dec]', $this.container)
			$this.quantityInc = $('[data-quantity-inc]', $this.container)
			$this.quantityInput = $('[data-quantity-input]', $this.container)
			if ($this.data.bundleProducts) {
				$this.data.bundleProducts = $this.data.bundleProducts.split(',')
				$this.data.bundleProducts.push($this.data.variantId)
			}

			$this.initQuantityInput()
		}

		$this.initQuantityInput = function () {
			$this.quantityDec.on('click', function () {
				$this.updateQuantity('dec')
			})
			$this.quantityInc.on('click', function () {
				$this.updateQuantity('inc')
			})
			$this.quantityInput.on('keyup', function () {
				let $val = parseInt($this.quantityInput.val())
				$this.timeout = setTimeout(function () {
					$events.dispatch($events.types.QuantityUpdated, {
						target: $this.container,
						value: $val,
					})
				}, 250)
			})
		}

		$this.updateQuantity = function ($dir) {
			clearTimeout($this.timeout)
			let $val = parseInt($this.quantityInput.val())
			if ($dir == 'dec') {
				if ($val == $this.data.minValue) return
				$val -= 1
			}
			if ($dir == 'inc') {
				if ($val == $this.data.maxValue) return
				$val += 1
			}
			$this.quantityInput.val($val)
			let updates = false
			if ($this.data.bundleProducts) {
				updates = []
				$this.data.bundleProducts.forEach((product) => {
					updates.push(product)
				})
			}
			$this.timeout = setTimeout(function () {
				$events.dispatch($events.types.QuantityUpdated, {
					target: $this.container,
					value: $val,
					updates: updates,
				})
			}, 250)
		}

		$this.init()
		return $this
	}
	Shopify.theme.QuantityComponent = QuantityComponent
})()

/**
 * Cart
 * Cart Display
 * Initializes line item remove + quantity updates
 * Listes for removed and quantity updates
 * cart.js
 **/
;(function () {
	Shopify.theme = Shopify.theme || {}
	let $theme = Shopify.theme
	let $events = Shopify.theme.eventBus
	let $cartService = Shopify.theme.CartService

	let Cart = function ($container) {
		let $this = {}
		$this.classes = {
			cartEmpty: 'empty',
		}
		$this.selectors = {
			cartItem: '[data-cart-item]',
			cartSubItem: '[data-cart-sub-item]',
			cartRemove: '[data-cart-remove]',
			cartCount: '[data-cart-count]',
			cartSubTotal: '[data-cart-subtotal]',
			cartItemRegularPrice: '[data-cart-item-regular-price]',
			cartAjaxContainer: '[data-ajax-container]',
		}
		$this.attributes = {
			sideBarCart: 'data-sidebar-cart',
			cartItemIndex: 'data-cart-item-index',
			cartItemKey: 'data-cart-item-key',
			cartItemBundleProducts: 'data-cart-item-bundle-products',
			cartItemVariantId: 'data-cart-item-variant-id',
			cartItemQuantity: 'data-cart-item-quantity',
			cartItemTitle: 'data-cart-item-title',
			cartItemUrl: 'data-cart-item-url',
			uid: 'data-cart-item-uid',
			quantityItem: 'data-quantity-item',
		}
		$this.init = function () {
			$this.initElements()
			$events.on($events.types.CartUpdated, $this.onCartUpdated)
			$events.on($events.types.QuantityUpdated, $this.onQuantityUpdated)
			$this.type =
				$this.container.data('cart-type') == 'sidebar' ? 'sidebar' : 'page'
			if ($this.type == 'sidebar') {
				$events.on($events.types.AddedToCart, function ($item) {
					if ($item.detail.success == true) {
						$this.cartAjaxContainer.load('/cart?view=ajax', function () {
							$events.dispatch($events.types.AjaxCartRefreshed)
							$this.initElements()
						})
					}
				})
			}
		}

		$this.initElements = function () {
			$this.container.on('click', $this.selectors.cartRemove, $this.removeItem)
			$this.cartCount = $($this.selectors.cartCount, $this.container)
			$this.cartSubTotal = $($this.selectors.cartSubTotal, $this.$container)
			$this.cartAjaxContainer = $(
				$this.selectors.cartAjaxContainer,
				$this.$container,
			)
			$($this.container.find('[sh-quantity-component]')).each(function ($e) {
				new $theme.QuantityComponent($(this))
			})
		}

		$this.removeItem = function ($e) {
			$e.preventDefault()
			// if( !confirm( 'Are you sure you would like to remove this item from your cart?')){
			// 	return false
			// }
			var $remove = $($e.target)
			var $lineItem = $remove.closest($this.selectors.cartItem)
			var key = $lineItem.attr($this.attributes.cartItemKey)
			var bundleProducts = $lineItem.attr(
				$this.attributes.cartItemBundleProducts,
			)
			const uid = $lineItem.attr($this.attributes.uid)
			const cartItem = $cartService.getCartItemByUID(uid)
			if (cartItem) {
				key = cartItem.key
			}
			if (typeof bundleProducts !== 'undefined') {
				let childKeys = {}
				childKeys[key] = 0
				let childProudcts = $lineItem.find($this.selectors.cartSubItem)
				if (childProudcts) {
					childProudcts.each(function (e) {
						let $childLineItem = $(this)
						var childKey = $childLineItem.attr($this.attributes.cartItemKey)
						const childUid = $childLineItem.attr($this.attributes.uid)
						const childCartItem = $cartService.getCartItemByUID(childUid)
						if (childCartItem) {
							childKey = childCartItem.key
							childKeys[childKey] = 0
						}
					})
				}

				$cartService
					.updateQuantity__update(childKeys)
					.then(function (response) {
						if (response.success) {
							$lineItem.fadeOut()
						}
					})
			} else {
				$cartService.removeItem(key).then(function (response) {
					if (response.success) {
						$lineItem.fadeOut()
					}
				})
			}
		}

		$this.removeItems = function (keys, i = 0, $lineItem) {
			let key = keys[i]
			$cartService.removeItem(key, false).then((res) => {
				i++
				if (keys[i]) {
					$this.removeItems(keys, i, $lineItem)
				} else {
					$lineItem.fadeOut()
					$events.dispatch($events.types.CartUpdated, $cartService.cart)
				}
			})
		}

		$this.updateCart = function () {}

		$this.onQuantityUpdated = function ($event) {
			var $target = $($event.detail.target)
			var $lineItem = $target.closest($this.selectors.cartItem)
			var key = $lineItem.attr($this.attributes.cartItemKey)
			const uid = $lineItem.attr($this.attributes.uid)
			const cartItem = $cartService.getCartItemByUID(uid)
			const newQuantity = $event.detail.value

			if (cartItem) {
				key = cartItem.key
			}

			if ($event.detail.updates) {
				let childKeys = {}
				childKeys[key] = newQuantity
				let childProudcts = $lineItem.find('[data-cart-sub-item]')
				if (childProudcts) {
					childProudcts.each(function (e) {
						let $childLineItem = $(this)
						var childKey = $childLineItem.attr($this.attributes.cartItemKey)
						const childUid = $childLineItem.attr($this.attributes.uid)
						const childCartItem = $cartService.getCartItemByUID(childUid)
						if (childCartItem) {
							let multipler = 1
							if (childCartItem.properties._bundle_quantity_multiplier) {
								multipler = childCartItem.properties._bundle_quantity_multiplier
							}
							childKey = childCartItem.key
							childKeys[childKey] = newQuantity * multipler
						}
					})
				}
				$cartService.updateQuantity__update(childKeys).then(function (res) {
					if (res.success && $event.detail.value == 0) {
						$lineItem.fadeOut()
					}
				})
			} else {
				$cartService
					.updateQuantity(key, $event.detail.value)
					.then(function (res) {
						if (res.success && $event.detail.value == 0) {
							$lineItem.fadeOut()
						}
					})
			}
		}

		$this.updateQuantities = function (keys, i = 0, $value) {
			let key = keys[i]
			$cartService.updateQuantity(key, $value, false).then(function (res) {
				i++
				if (keys[i]) {
					$this.updateQuantities(keys, i, $value)
				} else {
					$this.onCartUpdated()
				}
			})
		}

		updatePriceText = function () {
			const cartService = $cartService
			const { selectors } = $this
			const lineItems = document.querySelectorAll(selectors.cartItem)

			lineItems.forEach((lineItem) => {
				const dataset = lineItem.dataset

				const bundleProducts = dataset.cartItemBundleProducts
				const priceText = lineItem.querySelector(
					'[data-cart-item-regular-price="single"]',
				)

				if (bundleProducts && typeof bundleProducts !== 'undefined') {
					let bundleTotal = 0
					const childItems = lineItem.querySelectorAll(selectors.cartSubItem)

					childItems.forEach((childItem) => {
						const childDataset = childItem.dataset
						const childUid = childDataset.cartItemUid
						const childCartItem = cartService.getCartItemByUID(childUid)

						if (childCartItem) {
							bundleTotal += childCartItem.original_price
						}

						childItem.querySelector(
							'[data-cart-item-regular-price]',
						).textContent = Shopify.formatMoney(childCartItem.original_price)
					})

					priceText.textContent = Shopify.formatMoney(bundleTotal)
				}
			})
		}

		$this.onCartUpdated = function () {
      $cartService.addCustomItemCount();
      
			if ($cartService.cart.item_count == 0) {
				$this.container.addClass($this.classes.cartEmpty)
			} else {
				$this.container.removeClass($this.classes.cartEmpty)
			}

      $this.cartCount.text($cartService.customCount);

			$this.cartSubTotal.text(
				Shopify.formatMoney($cartService.cart.total_price),
			)

			updatePriceText()
		}

		$this.container = $($container)
		if ($this.container.length > 0) {
			$this.init()
		}
	}
	Shopify.theme.Cart = new Cart('[data-cart-wrapper]')
})()

/**
 * NavCart Component
 * Mini cart display
 * Listens for changes in cart quantity
 * nav-cart.js
 **/
;(function () {
	Shopify.theme = Shopify.theme || {}
	let $events = Shopify.theme.eventBus
	let $cartService = Shopify.theme.CartService
	let NavCartComponent = function ($containerElement) {
		let $this = {}
		$this.container = $($containerElement)
		$this.classes = {
			loading: 'loading',
			empty: 'empty',
		}

		$this.init = function () {
			$this.count = $('[data-cart-count]', $this.container)
			$events.on($events.types.AddingToCart, $this.addingToCart)
			$events.on($events.types.AddedToCart, $this.addedToCart)
			$events.on($events.types.CartUpdated, $this.cartUpdated)
		}
		$this.addingToCart = function () {
			$this.container.addClass($this.classes.loading)
		}
		$this.addedToCart = function ($data) {
			$this.container.removeClass($this.classes.loading)
		}
		$this.cartUpdated = function ($event) {
			let $count = $cartService.customCount
			if ($count == 0 || typeof $count == 'undefined') {
				$this.container.addClass('empty')
				$this.count.text('')
			} else {
				$this.container.removeClass('empty')
			}
			$this.count.text($count)
		}

		return $this
	}
	Shopify.theme.NavCartComponent = NavCartComponent
	$('[data-nav-cart]').each(function (e) {
		let $container = $(this)
		let component = NavCartComponent($container)
		component.init()
	})
})()

const itemUID = function (item) {
  const uid = btoa(item.id + JSON.stringify(item.properties));
  return uid;
};

/**
 * convert the formdata to a nested object
 **/
const convertFormData = function (formData) {
  const result = {};
  let formDataObject = Object.assign(
    ...Array.from(formData.entries(), ([x, y]) => ({ [x]: y })),
  );

  Object.keys(formDataObject).forEach((key) => {
    const parts = key.split(/[\[\]]+/).filter(Boolean);
    let current = result;
    while (parts.length > 1) {
      const part = parts.shift();
      if (!current[part] && typeof current !== 'undefined') {
        current[part] = isNaN(parts[0]) ? {} : [];
      }
      current = current[part];
    }
    current[parts[0]] = formDataObject[key];
  });

  return result;
};



/**
 * Custom Object for setting up an option select on a product
 * Where the product is created a new Shopify.theme.currentProduct is created
 * either as an object or as an id
 * if it is an object the product.id must be used as the id
 * product-form.js
 **/
;(function () {
	Shopify.theme = Shopify.theme || {}
	let $theme = Shopify.theme
	let $events = Shopify.theme.eventBus
	let ProductForm = function ($product_or_id = false, $container = false) {
		let $this = {}
		$this.product_or_id = $product_or_id
		if ($container) $this.container = $container
		$this.productSelect = false
		$this.productJson = false
		$this.variantOptions = {}
		$this.optionsInitialized = false

		$this.classes = {
			cartPopupWrapperHidden: 'cart-popup-wrapper--hidden',
			hidden: 'd-none',
			visibilityHidden: 'sr-only',
			inputError: 'input--error',
			productOnSale: 'price--on-sale',
			productUnitAvailable: 'price--unit-available',
			productUnavailable: 'price--unavailable',
			productSoldOut: 'price--sold-out',
			cartImage: 'cart-popup-item__image',
			productFormErrorMessageWrapperHidden:
				'product-form__error-message-wrapper--hidden',
			variantSoldOut: 'product-form--variant-sold-out',
			addingToCart: 'loading',
		}
		$this.selectors = {
			addToCart: '[data-add-to-cart]',
			addToCartText: '[data-add-to-cart-text]',
			loader: '[data-loader]',
			productForm: '[data-product-form]',
			priceContainer: '[data-price]',
			regularPrice: '[data-regular-price]',
			salePrice: '[data-sale-price]',
			unitPrice: '[data-unit-price]',
			unitPriceBaseUnit: '[data-unit-price-base-unit]',
			productPolicies: '[data-product-policies]',
			swatchOptions: '[data-swatch-option]',
			swatchValues: '[data-swatch-value]',
			optionSelect: '[sh-option-select]',
		}

		$this.init = function () {
			if ($this.product_or_id) {
				// if product init product
				let product = $this.validateProduct($this.product_or_id)
				if (product) {
					$this.initProduct(product, $this.product_or_id)
				}
			}
		}
		$this.validateProduct = function (product_or_id) {
			let product = false
			if (typeof product_or_id == 'object') {
				product = product_or_id
			} else if (typeof product_or_id == 'string') {
				try {
					product = JSON.parse(
						document.getElementById('ProductJson-' + product_or_id).innerHTML,
					)
				} catch ($e) {
					product = false
				}
			}
			return product
		}
		/**
		 * Accepts a product object or id
		 * If a product object is passed, it expects the container and ProductSelect
		 * to have the product ID specifically on their ids ProductXXX-product.id
		 *
		 */
		$this.initProduct = function (product, product_or_id) {
			$this.product = product
			let select = $($this.container.find($this.selectors.optionSelect))
			$this.productSelect = select.attr('id')
			if (typeof $this.productSelect == 'undefined') $this.productSelect = false
			$this.createOptionMap()
			$this.addElements()
			$this.QuantityComponent = new $theme.QuantityComponent(
				$this.container.find('[sh-quantity-component]'),
			)
			// initialize product selector
			if ($this.product.variants.length > 1 && $this.productSelect) {
				$this.addSelectCallBack()
			}
			// add to cart handler
			$($this.selectors.productForm, $this.container).on(
				'submit',
				function ($e) {
					$e.preventDefault()
					$this.addToCart()
				},
			)

			return $this.product
		}

		$this.addElements = function () {
			$this.form = $($this.selectors.productForm, $this.container)

			$this.$addToCart = $($this.selectors.addToCart, $this.container)
			$this.$addToCartText = $($this.selectors.addToCartText, $this.$addToCart)

			$this.swatchOptions = $($this.selectors.swatchOptions, $this.container)
			$this.swatchValues = $($this.selectors.swatchValues, $this.container)
			if ($this.swatchOptions.length > 0) {
				$this.initSwatchOptions()
			}

			$this.priceContainer = $($this.selectors.priceContainer, $this.container)
			$this.regularPrice = $($this.selectors.regularPrice, $this.priceContainer)
			$this.salePrice = $($this.selectors.salePrice, $this.priceContainer)
			$this.unitPrice = $($this.selectors.unitPrice, $this.priceContainer)
			$this.unitPriceBaseUnit = $(
				$this.selectors.unitPriceBaseUnit,
				$this.priceContainer,
			)
		}

		$this.addSelectCallBack = function () {
			let selector = new Shopify.OptionSelectors($this.productSelect, {
				product: $this.product,
				onVariantSelected: $this.selectCallback,
			})
		}

		$this.selectCallback = function (variant, selector) {
			if ($this.optionsInitialized == false) {
				$this.initOptionSelectors()
			}
			$this.variant = variant
			$this.resetState()
			$this.updatePrice()
			$this.updateAddToCart()
			$events.dispatch($events.types.OptionsSelected, variant)
		}

		$this.resetState = function () {
			$this.priceContainer
				.removeClass($this.classes.productUnavailable)
				.removeClass($this.classes.productOnSale)
				.removeClass($this.classes.productUnitAvailable)
				.removeClass($this.classes.productSoldOut)
				.removeAttr('aria-hidden')

			$this.container
				.removeClass($this.classes.productUnavailable)
				.removeClass($this.classes.productOnSale)
				.removeClass($this.classes.productUnitAvailable)
				.removeClass($this.classes.productSoldOut)
				.removeAttr('aria-hidden')
		}

		$this.updatePrice = function () {
			// this.$productPolicies.removeClass(this.classes.visibilityHidden);
			// Unavailable
			if (!$this.variant) {
				$this.update_variant_unavailable()
				return
			}
			// Sold out
			if (!$this.variant.available) {
				$this.update_variant_unavailable()
			}
			// On sale
			if ($this.variant.compare_at_price > $this.variant.price) {
				$this.update_variant_on_sale()
			} else {
				$this.update_variant_regular()
			}
			// Unit price
			if ($this.variant.unit_price) {
				$this.update_variant_unit()
			}
		}

		$this.createOptionMap = function () {
			$this.optionsMap = []
			for (var i = 0; i < $this.product.variants.length; i++) {
				var variant = $this.product.variants[i]
				if (variant.available) {
					// Gathering values for the 1st drop-down.
					$this.optionsMap['root'] = $this.optionsMap['root'] || []
					$this.optionsMap['root'].push(variant.option1)
					$this.optionsMap['root'] = Shopify.uniq($this.optionsMap['root'])
					// Gathering values for the 2nd drop-down.
					if ($this.product.options.length > 1) {
						var key = variant.option1
						$this.optionsMap[key] = $this.optionsMap[key] || []
						$this.optionsMap[key].push(variant.option2)
						$this.optionsMap[key] = Shopify.uniq($this.optionsMap[key])
					}
					// Gathering values for the 3rd drop-down.
					if ($this.product.options.length === 3) {
						var key = variant.option1 + ' / ' + variant.option2
						$this.optionsMap[key] = $this.optionsMap[key] || []
						$this.optionsMap[key].push(variant.option3)
						$this.optionsMap[key] = Shopify.uniq($this.optionsMap[key])
					}
				}
			}
		}

		$this.initOptionSelectors = function () {
			$this.optionsInitialized = true
			// Update options right away.
			$this.updateOptionsInSelector(0)
			if ($this.product.options.length > 1) $this.updateOptionsInSelector(1)
			if ($this.product.options.length === 3) $this.updateOptionsInSelector(2)
			// When there is an update in the first dropdown.
			$('.single-option-selector:eq(0)').change(function () {
				$this.updateOptionsInSelector(1)
				if ($this.product.options.length === 3) $this.updateOptionsInSelector(2)
				return true
			})
			// When there is an update in the second dropdown.
			$('.single-option-selector:eq(1)').change(function () {
				if ($this.product.options.length === 3) $this.updateOptionsInSelector(2)
				return true
			})
			if ($this.product.options.length > 0) {
				if ($('.single-option-selector:eq(0) option').length == 1) {
					$('.single-option-selector:eq(0)').addClass('single-option')
				}
			}
			if ($this.product.options.length > 1) {
				if ($('.single-option-selector:eq(1) option').length == 1) {
					$('.single-option-selector:eq(1)').addClass('single-option')
				}
			}
			if ($this.product.options.length > 2) {
				if ($('.single-option-selector:eq(2) option').length == 1) {
					$('.single-option-selector:eq(2)').addClass('single-option')
				}
			}
		}

		$this.updateOptionsInSelector = function (selectorIndex) {
			switch (selectorIndex) {
				case 0:
					var key = 'root'
					var selector = $('.single-option-selector:eq(0)')
					break
				case 1:
					var key = $('.single-option-selector:eq(0)').val()
					var selector = $('.single-option-selector:eq(1)')
					break
				case 2:
					var key = $('.single-option-selector:eq(0)').val()
					key += ' / ' + $('.single-option-selector:eq(1)').val()
					var selector = $('.single-option-selector:eq(2)')
			}

			var initialValue = selector.val()
			selector.empty()
			var availableOptions = $this.optionsMap[key]
			if (typeof availableOptions == 'undefined') return
			for (var i = 0; i < availableOptions.length; i++) {
				var option = availableOptions[i]
				var newOption = $('<option></option>').val(option).html(option)
				selector.append(newOption)
			}
			if ($.inArray(initialValue, availableOptions) !== -1) {
				selector.val(initialValue)
			}
			if ($this.swatchOptions.length > 0) {
				$(
					'.swatch[data-option-index="' + selectorIndex + '"] .swatch-element',
				).each(function () {
					let $value = $(this).data('value')
					let option = $(this)
					if ($.inArray($value, availableOptions) !== -1) {
						option.show().find(':radio').removeAttr('disabled', 'disabled')
						if ($this.variant != null) {
							if (selectorIndex == 0 && $value == $this.variant.option1) {
								option.attr('checked', 'checked')
							}
							if (selectorIndex == 1 && $value == $this.variant.option2) {
								option.attr('checked', 'checked')
							}
							if (selectorIndex == 2 && $value == $this.variant.option3) {
								option.attr('checked', 'checked')
							}
						}
					} else {
						option
							.hide()
							.find(':radio')
							.removeAttr('checked')
							.attr('disabled', 'disabled')
					}
				})

				if ($this.variant == null) {
					var first = $($("input[name='option-" + selectorIndex + "']")[0])
					first.trigger('click')
				}
			}

			selector.trigger('change')
		}

		// update the add to cart button on variant change
		$this.updateAddToCart = function () {
			if ($this.variant) {
				if ($this.variant.available) {
					$this.$addToCart
						.removeAttr('aria-disabled')
						.attr('aria-label', theme.strings.addToCart)
					$($this.selectors.addToCartText, $this.container).text(
						theme.strings.addToCart,
					)
					$($this.selectors.productForm, $this.container).removeClass(
						$this.classes.variantSoldOut,
					)
				} else {
					// Variant is sold out, disable submit button and change the text.
					$this.$addToCart
						.attr('aria-disabled', true)
						.attr('aria-label', theme.strings.soldOut)
					$($this.selectors.addToCartText, $this.container).text(
						theme.strings.soldOut,
					)
					$($this.selectors.productForm, $this.container).addClass(
						$this.classes.variantSoldOut,
					)
				}
			} else {
				// The variant doesn't exist, disable submit button and change the text.
				$this.$addToCart
					.attr('aria-disabled', true)
					.attr('aria-label', theme.strings.unavailable)
				$($this.selectors.addToCartText, $this.container).text(
					theme.strings.unavailable,
				)
				$($this.selectors.productForm, $this.container).addClass(
					$this.classes.variantSoldOut,
				)
			}
		},

    $this.update_variant_unavailable = function () {
      $this.container.addClass($this.classes.productUnavailable)
      $this.priceContainer
        .addClass($this.classes.productUnavailable)
        .attr('aria-hidden', true)
      // this.$productPolicies.addClass(this.classes.visibilityHidden);
    }

		$this.update_variant_regular = function () {
			$this.regularPrice.html(Shopify.formatMoney($this.variant.price))
		}

		$this.update_variant_on_sale = function () {
			$this.regularPrice.html(
				Shopify.formatMoney($this.variant.compare_at_price),
			)
			$this.salePrice.html(Shopify.formatMoney($this.variant.price))
			$this.priceContainer.addClass($this.classes.productOnSale)
		}

		$this.update_variant_unit = function () {
			$this.unitPrice.html(
				$theme.Currency.formatMoney(
					$this.variant.unit_price,
					$theme.moneyFormat,
				),
			)
			$this.unitPriceBaseUnit.html($this._getBaseUnit($this.variant))
			$this.priceContainer.addClass($this.classes.productUnitAvailable)
		}

		$this.addToCart = function () {

			const formData = new FormData($this.form[0])
			let data = {
				items: $this.addCartItems(formData),
			};
				

			let params = { url: '/cart/add.js', data: data, dataType: 'json' }
			$events.dispatch($events.types.AddingToCart, $this.product)
			$.post(params)
				.done(function (response) {
					let result = {items : false, variant : false , success: true }
					if (response.items) {
						result.items = response.items
					}else{
						result.variant = response
					}
					$events.dispatch($events.types.AddedToCart, result)
				})
				.fail(
					function (response) {
						alert(response.responseJSON.description)
						$events.dispatch($events.types.AddedToCart, { success: false })
					}.bind($this),
				)
		}

		$this.addedToCart = function (response) {
			document.dispatchEvent(
				new CustomEvent('mx_shopify.product.added_to_cart', response),
			)
		}

		$this.addCartItems = function (formData) {
			let item = {};
			let formDataObject = convertFormData(formData);
			if (!formDataObject.hasOwnProperty('properties')) {
				formDataObject.properties = {};
			}
			formDataObject.properties._uid = itemUID(formDataObject);
	
			for (key in formDataObject) {
				if (key == 'items') {
					formDataObject.items.forEach((item) => {
						if (!item.hasOwnProperty('properties')) {
							item.properties = {};
						}
						item.properties._uid = itemUID(item);
					});
				} else {
					item[key] = formDataObject[key];
				}
			}
	
			let items = [item];
			if (formDataObject.hasOwnProperty('items')) {
				formDataObject.items = formDataObject.items.filter(Boolean);
				items = [...items, ...formDataObject.items];
			}
			return items;
		};
		$this.initSwatchOptions = function () {
			let radios = $($this.swatchOptions.find(':radio'))
			radios.change(function () {
				var optionIndex = $(this)
					.closest($this.selectors.swatchOptions)
					.attr('data-option-index')
				var optionValue = $(this).val()
				$this.form
					.find('.single-option-selector')
					.eq(optionIndex)
					.val(optionValue)
					.trigger('change')
			})
		}
		$this.itemUID = function (item) {
			const uid = btoa(item.id + JSON.stringify(item.properties))
			return uid
		}

		return $this
	}
	$('[sh-product-form]').each(function (e) {
		let data = $(this).data()
		if (typeof data.productId != 'undefined') {
			let $el = this
			let product_data = $($($el).find('.product-json'))
			try {
				product_data = JSON.parse(product_data.text())
			} catch ($e) {
				console.log($e)
			}
			if (product_data) {
				let product = new ProductForm(product_data, $($el))
				product.init()
			}
		}
	})
})()
